import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="py-8 border-t border-white/5" data-id="element-24">
        <div className="max-w-4xl mx-auto px-4 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-25">
          <div data-id="element-26">
            <p className="text-slate-500 text-sm" data-id="element-27">
              © {new Date().getFullYear()} Primer Empleo Remoto. Todos los
              derechos reservados.
            </p>
            <p className="text-slate-600 text-xs mt-1" data-id="element-28">build: 2026-03-23-v3</p>
          </div>
          <div className="flex items-center gap-6" data-id="element-29">
            <button onClick={() => setShowPrivacy(true)} className="text-slate-500 text-sm hover:text-slate-300 transition-colors" data-id="element-30">
              Política de Privacidad
            </button>
            <button onClick={() => setShowTerms(true)} className="text-slate-500 text-sm hover:text-slate-300 transition-colors" data-id="element-31">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-32">
        <p data-id="element-33">
          <strong className="text-white" data-id="element-34">Última actualización:</strong> Marzo
          2026
        </p>
        <p data-id="element-35">
          En Primer Empleo Remoto, respetamos tu privacidad y nos comprometemos
          a proteger tus datos personales. Esta política describe cómo
          recopilamos, usamos y protegemos tu información.
        </p>
        <h4 className="text-white font-semibold pt-2" data-id="element-36">
          1. Información que recopilamos
        </h4>
        <p data-id="element-37">
          Recopilamos únicamente la información necesaria para procesar tu
          compra: nombre, dirección de correo electrónico y datos de pago. No
          almacenamos datos de tarjetas de crédito directamente; estos son
          procesados por plataformas de pago seguras de terceros.
        </p>
        <h4 className="text-white font-semibold pt-2" data-id="element-38">
          2. Uso de la información
        </h4>
        <p data-id="element-39">
          Tu información se utiliza exclusivamente para: entregar el producto
          digital adquirido, enviar actualizaciones relacionadas con tu compra y
          mejorar nuestros servicios. No vendemos, alquilamos ni compartimos tu
          información personal con terceros con fines de marketing.
        </p>
        <h4 className="text-white font-semibold pt-2" data-id="element-40">
          3. Protección de datos
        </h4>
        <p data-id="element-41">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información contra acceso no autorizado, pérdida o
          alteración.
        </p>
        <h4 className="text-white font-semibold pt-2" data-id="element-42">4. Cookies</h4>
        <p data-id="element-43">
          Podemos utilizar cookies esenciales para el funcionamiento del sitio y
          cookies analíticas para comprender cómo los usuarios interactúan con
          nuestra página. Puedes desactivar las cookies en la configuración de
          tu navegador.
        </p>
        <h4 className="text-white font-semibold pt-2" data-id="element-44">5. Tus derechos</h4>
        <p data-id="element-45">
          Tienes derecho a acceder, rectificar o eliminar tus datos personales
          en cualquier momento. Para ejercer estos derechos, puedes comunicarte
          con nosotros a través de los canales indicados en tu confirmación de
          compra.
        </p>
      </Modal>

      {/* Terms & Conditions Modal */}
      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-46">
        <p data-id="element-47">
          <strong className="text-white" data-id="element-48">Última actualización:</strong> Marzo
          2026
        </p>
        <p data-id="element-49">
          Al adquirir "Primer Empleo Remoto: El Kit de Supervivencia", aceptas
          los siguientes términos y condiciones. Por favor, léelos
          cuidadosamente antes de realizar tu compra.
        </p>
        <h4 className="text-white font-semibold pt-2" data-id="element-50">1. Producto digital</h4>
        <p data-id="element-51">
          Este es un producto digital (PDF y materiales complementarios) que se
          entrega de forma inmediata tras la confirmación del pago. No se trata
          de un servicio de consultoría, empleo garantizado ni asesoría legal.
        </p>
        <h4 className="text-white font-semibold pt-2" data-id="element-52">2. Licencia de uso</h4>
        <p data-id="element-53">
          Al comprar el producto, recibes una licencia personal e
          intransferible. Queda prohibida la reproducción, distribución, reventa
          o compartición del material con terceros sin autorización expresa.
        </p>
        <h4 className="text-white font-semibold pt-2" data-id="element-54">3. Resultados</h4>
        <p data-id="element-55">
          Los resultados descritos en la página de venta son ejemplos basados en
          experiencias reales, pero no constituyen una garantía de resultados
          específicos. Tu éxito dependerá de tu esfuerzo, dedicación y
          circunstancias individuales.
        </p>
        <h4 className="text-white font-semibold pt-2" data-id="element-56">
          4. Política de reembolso
        </h4>
        <p data-id="element-57">
          Debido a la naturaleza digital del producto y su entrega inmediata, no
          se ofrecen reembolsos una vez completada la descarga. Si experimentas
          problemas técnicos para acceder al material, te ayudaremos a
          resolverlos.
        </p>
        <h4 className="text-white font-semibold pt-2" data-id="element-58">5. Modificaciones</h4>
        <p data-id="element-59">
          Nos reservamos el derecho de actualizar estos términos en cualquier
          momento. Las modificaciones serán efectivas desde su publicación en
          esta página.
        </p>
        <h4 className="text-white font-semibold pt-2" data-id="element-60">6. Jurisdicción</h4>
        <p data-id="element-61">
          Estos términos se rigen por las leyes aplicables en la jurisdicción
          del comprador, en la medida que sean compatibles con la legislación
          internacional de comercio electrónico.
        </p>
      </Modal>
    </>;
}